// extracted by mini-css-extract-plugin
module.exports = {"inputFile":"audio-record-upload_inputFile__2tGGv","progressContainer":"audio-record-upload_progressContainer__1dzgW"};